<template>
  <div>
    <!-- Header Layout Content -->
    <div class="mdk-header-layout__content page-content">
      <div
        data-effects="parallax-background blend-background"
        class="mdk-box mdk-box--bg-gradient-primary bg-dark js-mdk-box position-relative overflow-hidden mb-0"
        data-domfactory-upgraded="mdk-box"
      >
        <div class="mdk-box__bg" style="visibility: visible;">
          <div
            class="mdk-box__bg-front"
            style="background-image: url(&quot;assets/images/1280_work-station-straight-on-view.jpg&quot;); transform: translate3d(0px, 0px, 0px); will-change: opacity; opacity: 1; margin-top: -138.761px;"
          ></div>
          <div
            class="mdk-box__bg-rear"
            style="transform: translate3d(0px, 0px, 0px); will-change: opacity; opacity: 0; margin-top: -138.761px;"
          ></div>
        </div>
        <div class="mdk-box__content">
          <div class="container page__container py-64pt py-md-112pt">
            <div class="row align-items-center text-center text-md-left">
              <div class="col-md-8 col-lg-8 order-1 order-md-0">
                <h1 class="text-white">
                  Integrated
                  <span>Platform</span>
                </h1>
                <p class="lead mb-48pt text-white">
                  Learn from specially prepared short courses designed
                  to help you progress in your chosen career and earn industry recognized
                  credentials.
                </p>
                <router-link
                  class="btn btn-lg btn-white btn--raised mb-16pt"
                  active-class="active"
                  :to="{name: 'dashboard'}"
                >Start learning</router-link>
              </div>
              <div class="col-md-6 col-lg-7 order-0 order-md-1 text-center mb-32pt mb-md-0"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-section bg-white border-bottom-2">
      <div class="container page__container">
        <div class="page-headline text-center">
          <h2>Learning Paths</h2>
          <p class="lead text-black-70 measure-lead mx-auto">
            Achieve your goals faster by following your
            pre-selected learning path
          </p>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-4">
              <div class="learning_path">
                <router-link
                  class="text-center"
                  active-class="active"
                  :to="{name: 'dashboard'}"
                >Software Engineering</router-link>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="learning_path">
                <router-link
                  class="text-center"
                  active-class="active"
                  :to="{name: 'dashboard'}"
                >Hardware Engineering</router-link>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="learning_path">
                <router-link
                  class="text-center"
                  active-class="active"
                  :to="{name: 'dashboard'}"
                >Creative Design</router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-8pt pt-md-32pt text-center">
          <a href="/dashboard" class="btn btn-outline-secondary">Browse Learning Paths</a>
        </div>
      </div>
    </div>

    <div class="page-section">
      <div class="container page__container">
        <div class="page-headline text-center">
          <h2>Feedback</h2>
          <p class="lead measure-lead mx-auto text-black-70">
            Here a a few testimonies of how the N-power Initiative has created opportunities for
            growth and advancement
          </p>
        </div>

        <div class="row d-block js-mdk-carousel">
          <div class="mdk-carousel__content"></div>
        </div>
        <ul class="pagination justify-content-center pagination-sm m-0">
          <li class="page-item disabled">
            <a class="page-link" href="#" aria-label="Previous">
              <span aria-hidden="true" class="material-icons">chevron_left</span>
              <span>Prev</span>
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" aria-label="Next">
              <span>Next</span>
              <span aria-hidden="true" class="material-icons">chevron_right</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- // END Header Layout Content -->

  <!-- // END Header Layout -->
</template>

<script>
export default {
  name: "Homepage",
  data() {
    return {};
  },
  mounted() {
    $(".preloader").fadeOut();
  }
};
</script>
